export const ADD_PERMISSIONS = 'ADD_PERMISSIONS'
export const LOAD_PERMISSIONS = 'LOAD_PERMISSIONS'
export const SET_PERMISSIONS_BY_TEAM = 'SET_PERMISSIONS_BY_TEAM'
export const SET_ACTIVE_TEAM = 'SET_ACTIVE_TEAM'


